"use client";
import React, { useEffect, useState } from "react";
import usePost from "@/hooks/usePost";
import useCart from "@/hooks/useCart";
import { useLoggedIn } from "@/store/useAuthStore";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import useNotify from "@/hooks/useNotify";
import useWishList from "@/hooks/useWishList";
import {
  redirectedPathNamee,
  translateCategoryFilter,
} from "../TopBar/component/LangSwitch";

const Wrapper = ({ children }: { children: React.ReactNode }) => {
  const { getCartList } = useCart();
  const { getWishList } = useWishList();
  const { getNotifyList } = useNotify();
  const { auth, login, logout } = useLoggedIn();
  const { PostMethod } = usePost();
  const pathName = usePathname();
  const router = useRouter();
  const searchParams = useSearchParams();

  if (pathName.split("/")[2] !== "product") {
    sessionStorage.removeItem("visibleColors");
    sessionStorage.removeItem("visibleSize");
  }
  if (pathName.split("/")[2] !== "orders") {
    sessionStorage.removeItem("initialModal");
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await PostMethod({
          url: "user/getUserProfile",
          method: "get",
        });

        if (res?.success) {
          login(true, res?.data);
          if (pathName.split("/")[1] !== res?.data?.language) {
            const translatedParams = await translateCategoryFilter(
              searchParams,
              pathName,
              res?.data?.language,
              PostMethod
            );
            router.replace(
              redirectedPathNamee(translatedParams, pathName, res?.data?.language)
            );
          }
        } else {
          logout(false);
        }
      } catch (error) {
        console.log("getProfile error : ", error);
      }
    };

    if (auth) {
      getWishList();
      getNotifyList();
    }

    fetchData();
    getCartList();

    // eslint-disable-next-line
  }, [auth]);

  useEffect(() => {
    if (pathName.split("/")[2] === "orderconfirmation") {
      getCartList();
    }
    // eslint-disable-next-line
  }, [pathName]);

  const removeCID = async (CID:any) => {
      try {
        const res = await PostMethod({
          url: `mainCart/clearCart/${CID}`,
          method: "delete",
        });

        if (res?.success) {
          sessionStorage.removeItem("CID");
        } else {
          console.log("checkout remove error");
        }
      } catch (error) {
        console.log("checkout remove error");
      }
  };

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;

    const segments = pathName.split("/");
    const second = segments[2] ?? "";
    const CID = sessionStorage.getItem("CID");

    if (
      CID &&
      (pathName === "/en" ||
        pathName === "/ar" ||
        second === "product" ||
        second === "cart" ||
        second === "orderconfirmation")
    ) {
      timeout = setTimeout(() => {
        removeCID(CID);
      }, 1000);
    }

    return () => clearTimeout(timeout);
    // eslint-disable-next-line
  }, [pathName]);

  return <>{children}</>;
};

export default Wrapper;
